import request from '../utils/request';
import { getToken } from '../utils/auth';
import { API_BASE_URL, MEDIA_BASE_URL, API_PATHS } from './config';

const { IMAGE } = API_PATHS;
const BASE_URL = (API_BASE_URL || '').replace(/\/$/, '');
const MEDIA_URL = MEDIA_BASE_URL || BASE_URL;

/** 扫描图片入库（仅超管） */
export const scanImages = (path) =>
    request(IMAGE.SCAN, {
        method: 'POST',
        body: JSON.stringify({ path }),
    });

/** 浏览可扫描目录（仅超管） */
export const browseImageScanPath = (path) => {
    const qs = path ? `?path=${encodeURIComponent(path)}` : '';
    return request(`${IMAGE.SCAN_BROWSE}${qs}`, { method: 'GET' });
};

/** 图片列表（超管/管理员全部，普通用户已分配） */
export const listImages = async ({ signal } = {}) => {
    const data = await request(IMAGE.LIST, { method: 'GET', signal });
    return Array.isArray(data) ? data : [];
};

export const getImageById = (id) => request(`${IMAGE.GET_BY_ID}/${id}`, { method: 'GET' });

export const assignImageAccess = (imageId, userId) =>
    request(`${IMAGE.ASSIGN}/${imageId}/user/${userId}`, { method: 'POST' });

export const revokeImageAccess = (imageId, userId) =>
    request(`${IMAGE.REVOKE}/${imageId}/user/${userId}`, { method: 'POST' });

export const deleteImage = (id) => request(`${IMAGE.DELETE}/${id}`, { method: 'POST' });

export const listImageAccessUsers = (imageId) =>
    request(`${IMAGE.ACCESS}/${imageId}`, { method: 'GET' });

function appendViewToken(base, imageId) {
    const path = `${base}${IMAGE.VIEW}/${imageId}`;
    const token = getToken();
    if (!token) {
        return path;
    }
    const sep = path.includes('?') ? '&' : '?';
    return `${path}${sep}token=${encodeURIComponent(token)}`;
}

/** 图片预览地址（img 标签无法带 Authorization，使用 token 查询参数） */
export const getImageViewUrl = (imageId) => appendViewToken(MEDIA_URL, imageId);
